import { render } from "./6th_question.vue?vue&type=template&id=e5873ad2&scoped=true"
import script from "./6th_question.vue?vue&type=script&lang=js"
export * from "./6th_question.vue?vue&type=script&lang=js"

import "./6th_question.vue?vue&type=style&index=0&id=e5873ad2&scoped=true&lang=css"

import exportComponent from "/Users/matsushitamasaya/webex/setouchi-webapp2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5873ad2"]])

export default __exports__